import { IAdFoxBannerTypeParams } from '@cian/adfox';
import { TAdFoxTemplateType } from '../../AdfoxBanner/components/OwnTemplates';

type TAdFoxBannerParams = {
  [key: string]: string;
};

const banners: Record<TAdFoxTemplateType, TAdFoxBannerParams> = {
  mainpageBrand: {
    p1: 'crutn',
    p2: 'fjjq',
  },
  tgb_suburban: {
    p1: 'cuobr',
    p2: 'hmvu',
    puid2: 'offer_suburban',
  },
};

function getBannerByType(type: TAdFoxTemplateType) {
  return banners[type];
}

export function typeParamsMiddleware(type: TAdFoxTemplateType): Promise<IAdFoxBannerTypeParams> {
  return Promise.resolve(getBannerByType(type));
}
